import { atom } from "recoil";

export interface ImageLightboxRect {
	top: number;
	left: number;
	width: number;
	height: number;
}

export interface ImageLightboxImage {
	src: string;
	alt?: string;
	originRect: ImageLightboxRect;
}

export type ImageLightboxState = ImageLightboxImage | undefined;

export const imageLightboxAtom = atom<ImageLightboxState>({
	key: "imageLightbox",
	default: undefined,
});

export const rectFromElement = (rect: DOMRect): ImageLightboxRect => ({
	top: rect.top,
	left: rect.left,
	width: rect.width,
	height: rect.height,
});
